import { TTheme } from '@/core/theme'
import { media } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { styled } from '@mui/system'
import { LinkButton } from '@/ui/components/buttons/link'
import Typography from '@/ui/components/typography'

export const MarketingWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 100px;
    padding: 40px 0;
    margin: 0 auto;
`

export const HeroSectionContainer = styled('div')<{ theme?: TTheme }>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: start;
    ${media.md`
        grid-template-columns: 1fr;
        gap: 40px;
    `}

    > div:first-child {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .description {
        color: ${({ theme }) => theme.colors.greys[600]};
        font-size: 18px;
        line-height: 1.5;
    }
`

export const HeroTitle = styled(Typography)<{ theme?: TTheme }>`
    line-height: 1.2;
    font-size: var(--font-size-xxxl);
    font-weight: var(--font-weight-regular);

    ${media.xl`
        font-size: var(--font-size-xxl);
    `}
    ${media.md`
        font-size: var(--font-size-xl);
    `}
`

export const ImageWrapper = styled('div')<{ theme?: TTheme }>`
    svg {
        width: 100%;
        height: auto;
        max-width: 640px;
        border-radius: 8px;
        display: block;
        ${media.lg`
            max-width: 520px;
        `}
        ${media.md`
            max-width: 100%;
        `}
    }
`

export const FeatureList = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 16px;
`

export const FeatureItem = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        width: 16px;
        height: 16px;
        color: ${({ theme }) => theme.colors.greys[500]};
    }

    p {
        color: ${({ theme }) => theme.colors.greys[600]};
        margin: 0;
    }
`

export const IntegrationSectionContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    justify-content: center;
    gap: 32px;
    flex-wrap: wrap;

    ${media.md`
        flex-direction: column;
        align-items: center;
    `}
`

export const FooterSection = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 120px;
    align-items: center;
    color: ${({ theme }) => theme.colors.greys[600]};
    text-align: center;

    .contact-link {
        margin-top: 100px;
        color: ${({ theme }) => theme.colors.semantic.contactExpertLink};
        text-decoration: none;
        font-weight: var(--font-weight-medium);
        transition: color 0.2s ease;
        cursor: pointer;
        &:hover {
            color: ${({ theme }) =>
                theme.colors.semantic.contactExpertLinkHover};
        }
    }
`

export const InfoBannerWrapper = styled('div')<{ theme?: TTheme }>`
    width: 100%;
    background-color: ${({ theme }) =>
        theme.colors.semantic.marketingInfoBannerBackground};
    padding: 20px;
    border-radius: 8px;
`

export const TermsOfServiceBannerWrapper = styled('div')`
    width: 100%;
`

export const DescriptionWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;
`

export const LinkButtonWrapper = styled(LinkButton)<{ theme?: TTheme }>`
    &:hover {
        color: ${({ theme }: { theme: TTheme }) =>
            theme.colors.semantic.activationButtonHover};
    }
`

export const ProviderInfoWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
`
